const PSOrientationBaseController = require('./PSOrientationBaseController');

const WidgetData = cc.Class({
    name: 'WidgetData',
    properties: {
		isAlignTop: {
            default: false,
            notify: function() {
                if (this.isAlignTop) {
                    this.isAlignVerticalCenter = false;
                }
            }
        },
		isAlignBottom: {
            default: false,
            notify: function() {
                if (this.isAlignBottom) {
                    this.isAlignVerticalCenter = false;
                }
            }
        },
		isAlignLeft: {
            default: false,
            notify: function() {
                if (this.isAlignLeft) {
                    this.isAlignHorizontalCenter = false;
                }
            }
        },
		isAlignRight: {
            default: false,
            notify: function() {
                if (this.isAlignRight) {
                    this.isAlignHorizontalCenter = false;
                }
            }
        },
        isAlignVerticalCenter: {
            default: false,
            notify: function() {
                if (this.isAlignVerticalCenter) {
                    this.isAlignTop = false;
                    this.isAlignBottom = false;
                }
            }
        },
		isAlignHorizontalCenter: {
            default: false,
            notify: function() {
                if (this.isAlignHorizontalCenter) {
                    this.isAlignLeft = false;
                    this.isAlignRight = false;
                }
            }
        },
		top: {
            default: 0,
            visible: function() { return this.isAlignTop }
        },
		bottom: {
            default: 0,
            visible: function() { return this.isAlignBottom }
        },
		left: {
            default: 0,
            visible: function() { return this.isAlignLeft }
        },
		right: {
            default: 0,
            visible: function() { return this.isAlignRight }
        }, 
		horizontalCenter: {
            default: 0,
            visible: function() { return this.isAlignHorizontalCenter }
        },
		verticalCenter: {
            default: 0,
            visible: function() { return this.isAlignVerticalCenter }
        },
		isAbsoluteHorizontalCenter: {
            default: false,
            visible: function() { return this.isAlignHorizontalCenter }
        },
		isAbsoluteVerticalCenter: {
            default: false,
            visible: function() { return this.isAlignVerticalCenter }
        },
		isAbsoluteTop: {
            default: false,
            visible: function() { return this.isAlignTop }
        },
		isAbsoluteBottom: {
            default: false,
            visible: function() { return this.isAlignBottom }
        },
		isAbsoluteLeft: {
            default: false,
            visible: function() { return this.isAlignLeft }
        },
		isAbsoluteRight: {
            default: false,
            visible: function() { return this.isAlignRight }
        },
    }
});

cc.Class({
    extends: PSOrientationBaseController,

    properties: {
        widget: cc.Widget,

        syncMobile: {
            default: false,
            notify: function() {
                if(this.syncMobile) {
                    this.copyDesktopDataToMobile();
                }
            }
        },

        landscapeDesktop: WidgetData,
        portraitDesktop: WidgetData,
        landscapeMobile: WidgetData,
        portraitMobile: WidgetData
    },

    onLoad () {
        this._super();
        this.isLoaded = true;

        if (this.lastConfig) {
            this._layout(this[this.lastConfig]);
        }
    },

    onLandscapeMobile () {
        this.lastConfig = 'landscapeMobile';
        this._layout(this.landscapeMobile);
    },

    onPortraitMobile () {
        this.lastConfig = 'portraitMobile';
        this._layout(this.portraitMobile);
    },

    onLandscapeDesktop () {
        this.lastConfig = 'landscapeDesktop';
        this._layout(this.landscapeDesktop);
    },

    onPortraitDesktop () {
        this.lastConfig = 'portraitDesktop';
        this._layout(this.portraitDesktop);
    },

    _layout (widgetData) {
        if (!this.isLoaded || !this.widget) {
            return;
        }
        this.copyFromTo(widgetData, this.widget);

        this.widget.updateAlignment();
    },

    copyDesktopDataToMobile () {
        this.copyFromTo(this.landscapeDesktop, this.landscapeMobile);
        this.copyFromTo(this.portraitDesktop, this.portraitMobile);
    },

    copyFromTo (from, to) {
        if (!from  || !to) {
            return;
        }

        to.isAlignTop = from.isAlignTop;
        to.isAlignLeft = from.isAlignLeft;
        to.isAlignBottom = from.isAlignBottom;
        to.isAlignRight = from.isAlignRight;
        to.isAlignHorizontalCenter = from.isAlignHorizontalCenter;
        to.isAlignVerticalCenter = from.isAlignVerticalCenter;
        to.isAbsoluteTop = from.isAbsoluteTop;
        to.isAbsoluteBottom = from.isAbsoluteBottom;
        to.isAbsoluteLeft = from.isAbsoluteLeft;
        to.isAbsoluteRight = from.isAbsoluteRight;
        to.isAbsoluteHorizontalCenter = from.isAbsoluteHorizontalCenter;
        to.isAbsoluteVerticalCenter = from.isAbsoluteVerticalCenter;
        to.top = from.top;
        to.bottom = from.bottom;
        to.left = from.left;
        to.right = from.right;
        to.verticalCenter = from.verticalCenter;
        to.horizontalCenter = from.horizontalCenter;
    }

});
